import React from 'react';
import CountUp from '../blocks/TextAnimations/CountUp/CountUp';

interface TouristCounterProps {
  count: number;
  className?: string;
}

export default function TouristCounter({ count, className = '' }: TouristCounterProps) {
  return (
    <div className={`tourist-counter ${className}`}>
      <p className="tourist-text">
        Join the <span className="tourist-count"><CountUp to={count} from={0} duration={2.5} /></span> art enthusiasts in your new journey
      </p>
    </div>
  );
} 